<template>
    <div class="invoice-container">
        <nav class="add-navigation flex-wrap flex">
            <div
                    @click="$router.push({ name: 'company-admin-users' })"
                    class="back-link my-2"
            >
                <svg
                        class="icon"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                    <path
                            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                            id="path-1"
                    />
                </svg>
                <p style="white-space: nowrap">Back to Users</p>
            </div>
            <div class="buttons-wrapper flex-wrap">
                <div
                        @click="$router.push({ name: 'company-admin-users' })"
                        class="secondary-button my-2"
                >
                    <secondary-button class="button_size">Cancel</secondary-button>
                </div>
                <div class="primary-button my-2">
                    <primary-button @click.native="addUser">Add User</primary-button>
                </div>
            </div>
        </nav>
        <div class="add-container">
            <span class="container-title">Add User</span>
            <div class="row p-3">
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="first name"
                            class="field"
                            :value="contact.first_name"
                            @input="handleFirstName"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('first name') }"
                            placeholder="Enter first name"
                    />
                    <div class="help is-danger" v-if="errors.has('first name')">
                        {{ errors.first("first name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="last name"
                            :value="contact.last_name"
                            @input="handleLastName"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('first name') }"
                            placeholder="Enter last name"
                    />
                    <div v-if="errors.has('last name')" class="help is-danger">
                        {{ errors.first("last name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="text"
                            name="user name"
                            v-model="contact.user_name"
                            v-validate="'required'"
                            :class="{ input: true, 'is-danger': errors.has('user name') }"
                            placeholder="Enter username"
                    />
                    <div class="help is-danger" v-if="errors.has('user name')">
                        {{ errors.first("user name") }}
                    </div>
                </div>
                <div class="col-md-6 col-12">
                    <primary-input
                            type="password"
                            name="password"
                            v-model="contact.passwd"
                            v-validate="'required'"
                            ref="password"
                            :class="{ input: true, 'is-danger': errors.has('password') }"
                            placeholder="********"
                    />
                    <div v-if="errors.has('password')" class="help is-danger">
                        {{ errors.first("password") }}
                    </div>
                </div>


                <div class="col-md-6 col-12">
                    <span class="filter_by">Status</span>
                    <primary-select v-model="contact.is_active" :options="isActiveOptions" placeholder="Select Status"/>
                </div>

                <div class="col-md-6 col-12">
                    <primary-input
                            type="password"
                            name="re-enter password"
                            v-validate="'required|confirmed:password'"
                            data-vv-as="password"
                            v-model="checkPassowrd"
                            :class="{input: true, 'is-danger': errors.has('re-enter password'),}"
                            placeholder="********"
                    />
                    <div class="help is-danger" v-if="errors.has('re-enter password')">
                        {{ errors.first("re-enter password") }}
                    </div>
                </div>

                <div class="col-md-6 col-12 d-flex flex-column">
                    <span class="ip-input-label">ALLOWED SMPP IP</span>
                    <vue-ip-input
                            name="ALLOWED SMPP IP"
                            :ip="contact.allowed_ip_list"
                            :on-change="onAllowedIpChange"
                            :class="{input: true, 'is-danger': errors.has('ALLOWED SMPP IP'),}"
                    ></vue-ip-input>
                    <div class="help is-danger" v-if="errors.has('ALLOWED SMPP IP')">
                        {{ errors.first("ALLOWED SMPP IP") }}
                    </div>
                </div>

                <div class="col-md-6 col-12 d-flex flex-column">
                    <span class="ip-input-label">Allowed API IP</span>
                    <vue-ip-input
                            name="Allowed API IP"
                            :ip="contact.allowed_api_ip_list"
                            :on-change="onAllowedApiIpChange"
                            :class="{input: true, 'is-danger': errors.has('Allowed API IP'),}"
                    ></vue-ip-input>
                    <div class="help is-danger" v-if="errors.has('Allowed API IP')">
                        {{ errors.first("Allowed API IP") }}
                    </div>
                </div>

<!--                <div class="col-md-6 col-12">-->
<!--                    <primary-input-->
<!--                            type="text"-->
<!--                            name="Allowed API IP"-->
<!--                            class="input"-->
<!--                            v-validate="'ip'" data-vv-as="ip"-->
<!--                            v-model="contact.allowed_api_ip_list"-->
<!--                            placeholder="Enter Allowed API IP"-->
<!--                    />-->
<!--                    <div class="help is-danger" v-if="errors.has('Allowed API IP')">-->
<!--                        {{ errors.first("Allowed API IP") }}-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import VueIpInput from 'vue-ip-input';

    export default {
        components: {
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            AppDropzone: () => import("@/components/Dropzone"),
            VueIpInput
        },
        data: () => ({
            contactError: null,
            role: ["Admin", "Normal"],
            contact: {
                first_name: null,
                last_name: null,
                user_name: null,
                passwd: null,
                is_active: false,
                allowed_api_ip_list: '',
                allowed_ip_list: '',
            },
            checkPassowrd: null,
            isActiveOptions: [],
            selectedDids: [],
            dids: [],
        }),
        created() {
            this.isActiveOptions.push({name: 'Active', value: true}, {name: 'Inactive', value: false})
            console.log("is")
            this.GetDidsList();
        },
        methods: {
            onAllowedIpChange(e) {
                this.contact.allowed_ip_list = e
            },
            onAllowedApiIpChange(e) {
                this.contact.allowed_api_ip_list = e
            },
            handleFirstName(v) {
                this.contact.first_name = this.$capitalize(v);
            },
            handleLastName(v) {
                this.contact.last_name = this.$capitalize(v);
            },
            async GetDidsList() {
                let {total} = await this.$store.dispatch("GetAllDids", {});

                const res = await this.$store.dispatch("GetAllDids", {perPage: total});

                this.dids = res.items;
            },
            addUser: async function () {
                const valid = await this.$validator.validate();

                if (valid) {
                    try {
                        const {object_id} = await this.$store.dispatch("AddUser", {
                            user: this.contact,
                        });

                        this.selectedDids.map((i) => {
                            this.$store.dispatch("AssignDidToUser", {
                                did: i.did,
                                data: {user_id: object_id},
                            });
                        });

                        this.$snotify.success("User have been added.", {
                            timeout: 6000,
                        });

                        this.$router.push({name: "company-admin-users"});
                    } catch (err) {
                        if (err.errors) {
                            this.contactError = err.errors[0].contact
                                ? err.errors[0].contact
                                : null;
                            setTimeout(() => {
                                this.contactError = null;
                            }, 6000);
                        } else if (err.response) {
                            let errmess = "";
                            for (var key in err.response.data.errors[0]) {
                                if (key == "user_name") {
                                    errmess += "User Name" + " " + err.response.data.errors[0][key];
                                }
                                if (key == "passwd") {
                                    errmess += "Password" + " " + err.response.data.errors[0][key];
                                } else {
                                    errmess += err.response.data.errors[0][key];
                                }
                            }
                            this.$snotify.error(
                                err.response.data.errors
                                    ? errmess
                                    : err.response.data.error.message,
                                {timeout: 6000}
                            );
                        } else {
                            this.$snotify.error(err, {timeout: 6000});
                        }
                    }
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .help {
        position: absolute;
        bottom: 0;
        left: 15px;
    }

    .invoice-container {
        font-family: "Helvetica Neue";
        padding: 0 20px;

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;

            width: 100%;
            margin-top: 20px;
            margin-bottom: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-content;

                .primary-button {
                    height: 40px;
                    width: 110px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 20px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;

            background-color: #ffffff;
            padding-top: 15px;

            .container-title {
                height: 30px;
                width: 432px;
                color: #000000;
                font-size: 16px;
                font-weight: 500;
                line-height: 30px;
                padding: 15px 0 15px 15px;
            }

            .col-wrapper {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-left: 15px;
                margin-top: 20px;

                .col {
                    width: 100%;
                    margin-right: 15px;
                    padding-left: 0;

                    .input {
                        margin-bottom: 20px;
                    }

                    .field {
                        p.pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                        }
                    }

                    .upload-photo,
                    #dropzone {
                        min-height: 285px;
                        min-height: 285px;
                        border-radius: 4px;
                        width: 100%;

                        .dz-image {
                            padding: 5px;

                            img {
                                height: 150px;
                                width: 150px;
                                border-radius: 50px;
                            }
                        }
                    }

                    .pimary-input-title {
                        color: #000000;
                        font-family: "Helvetica Neue";
                        font-size: 12px;
                        font-weight: 900;
                        letter-spacing: 0.21px;
                        line-height: 15px;
                        margin-bottom: 5px;
                        text-transform: uppercase;
                    }

                    .upload-contaioner {
                        border: 1px solid #5171f3;
                        border-radius: 4px;
                        background-color: #ffffff;
                        height: 265px;
                        border-style: dashed;
                        margin-right: 15px;
                        position: relative;

                        input[type="file"] {
                            position: absolute;
                            height: 36px;
                            width: 136px;
                            opacity: 0;
                            cursor: pointer;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
                            z-index: 1;
                        }

                        .upload-button {
                            height: 36px;
                            width: 136px;
                            border-radius: 4px;
                            background-color: #51a3f3;
                            margin: 0;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                        }
                    }
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }

    .row .input {
        margin-bottom: 20px;
    }

    @media (max-width: 319px) {
        .button_size {
            min-width: 110px !important;;
        }

    }
</style>

